import React, { Fragment, useState, useEffect, useCallback } from "react";
import { Alert } from "antd";

import { homepage } from "../../../../package.json";

import "./index.css";

const AlertMessage = ({ intl }) => {
  const [closed, setClosed] = useState();
  const handleClose = useCallback(() => setClosed(true), []);

  const [data, setData] = useState();
  useEffect(() => {
    fetch(`${homepage}/data/message.json`)
      .then((r) => r.json().then(setData).catch(console.log))
      .catch(console.log);
  }, []);

  const [alertValues, setAlertValues] = useState();
  useEffect(
    () =>
      data &&
      setAlertValues(
        intl.locale === "cs-CZ"
          ? { description: data.description, message: data.message }
          : { description: data.descriptionEn, message: data.messageEn }
      ),
    [intl, data]
  );

  return !closed && alertValues && data && data.show ? (
    <Alert
      showIcon
      closable
      type={data.type}
      onClose={handleClose}
      className="alert-container"
      message={alertValues.message}
      description={alertValues.description}
    />
  ) : (
    <Fragment />
  );
};

export default AlertMessage;
